import { CapoPlugin } from "/Users/klemen/Desktop/Development/kroznik/monorepo/kroznik_backoffice/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];